<template>
    <nav class="mobile-nav">
        <div class="mobile-menu">
           <span v-on:click="show = !show" >
               <img src="../assets/menu.svg" alt="">
           </span>
            <span>{{page}}
                <img src="../assets/logo.svg" alt="" height="40">
            </span>
        </div>
        <div class="disp">
            <transition-group class="trans" name="fade" tag="ul">
                <li v-bind:key="1" v-show="show" v-on:click="show = !show"><i class="fas fa-times"></i></li>
                <li v-bind:key="2" v-show="show"> <router-link to="/" href="">Home</router-link></li>
                <li v-bind:key="3" v-show="show"> <router-link to="/faq" href="">FAQs</router-link></li>
                <li v-bind:key="4" v-show="show"> <router-link to="/about" >About</router-link></li>
                <li v-bind:key="5" v-show="show">
                    <hr style="width: 80%; margin: 0 auto; opacity: 0.5"> </li>
                <li v-bind:key="6" v-show="show" v-on:click="show = !show"></li>

            </transition-group>


        </div>

    </nav>

</template>



<script>
export default {
  name: 'mobileNav',

    data: () => {
      return {
          show: false,
          page: ''
      }
    },

    methods: {
      togglePage(page) {
          this.show = !this.show;
          this.page = page;
      }
    }



}
</script>



<style lang="scss" scoped>
    /*.disp {*/
        /*display: block;*/
        /*position: absolute;*/
        /*background-color: #622586;*/
        /*width: 100vw;*/
        /*height: 100vh;*/

    /*}*/

    .mobile-menu {
        display: flex;
        justify-content: space-between;
        padding: 2% 0 0 0;

    }

    .mobile-nav {
        padding: 2% 5%;
        height: 50px;
        z-index: 1000;
        background-color: #fff;

        ul {
            position: absolute;
            top: 0;
            left: 0;
            height: 100vh;
            list-style: none;
            padding: 0;
            margin: 0;
            /*<!--background-color: rgba($color:#000, $alpha:0.3);-->*/

            a {
                text-decoration: none;
                color: #fff;
            }

            a,i {
                display: flex;
                justify-content: start;
                align-items: center;
                width: 60px;
                height: 60px;
                padding: 1% 10%;
            }

            li {
                display: flex;
                justify-content: flex-start;
                align-items: start;
                text-align: left;
                width: 100vw;
                height: 60px;
                /*<!--border-bottom: 1px solid rgba($color:#EBE2ED, $alpha:0.2);-->*/
                background-color: #622586;
                color: #fff;
                padding-bottom: 1rem;
                padding-left: 1rem;
            }
            li:first-child{
                justify-content: flex-end;

                i {
                    justify-content: flex-end;
                    font-size: 25px;
                }
            }
            li:nth-child(2) {
                padding-top: 2rem;
            }


            li:last-child {
                height: calc(100%);
                background-color: rgba($color:#622586, $alpha:1);

            }
        }
        .trans a {
           color: white;
            font-size: 35px;
            font-weight: 500;
        }
    }

    @mixin ul-childs($values...) {
        @each $var in $values {
            &:nth-child(#{$var}) {
                transition: transform linear calc(.05s * #{$var}), display .05s;
            }

        }
    }

    .fade-enter-active, .fade-leave-active {
        @include ul-childs(1,2,3,4,5)
    }

    .fade-enter, .fade-leave-to {
        transform: rotateY(-90);
    }


</style>
